import React from 'react';
import { useTranslation } from 'react-i18next';

import config from '../../config';
import { formatFullname } from '../../libraries/utils';
import Avatar from '../../components/commons/Avatar';
import Icon from '../../libraries/icons';

export default function NotifyElement({ data, ...rest }) {
  const { t, i18n } = useTranslation();

  const parsedSource = data.source.json_data && JSON.parse(data.source.json_data)
  const parsedTarget = data.target.json_data && JSON.parse(data.target.json_data)


  return (    
    <div key={rest.key} className="flex items-center p-3">
      <Avatar
        image={data.source.profile_image}
        label={data.source.username}
        className="rounded-full w-12 h-12"
      />
      <div className="ml-3 mr-auto">
        <p className="text-gray-700">
          <b>{formatFullname(parsedSource)}</b>{data.body}
        </p>
        <small className="text-gray-400">{t("timeRemains", { date: new Date(data.created_at) }).replace(config.TRANSLATE.TIME_REMAINS, '')}</small>
      </div>
    </div>
  )
}